import { latlngType } from 'features/predictionMap/types';
import { useEffect, useState } from 'react';

// 検索窓で指定されたlatlngない場合は現在地を用いる
const useGetLocation = () => {
  const [location, setLocation] = useState<latlngType>(null);
  useEffect(() => {
    if (!navigator.geolocation) {
      return;
    } else {
      navigator.geolocation.getCurrentPosition(position => {
        setLocation([position.coords.latitude, position.coords.longitude]);
      });
      return;
    }
  }, []);

  return location;
};

export default useGetLocation;
